import { Ajax } from './../Core/Ajax';
import { Constants } from './../Core/Constants';
import { Storage } from './../Core/Storage';
import { AppStore } from './../Core/AppStore';
import { CartProvider } from './CartProvider';
import { Customer } from './../Models/Customer';

export class UserProvider {

	static register(data, success, error) {
		Ajax.post(Constants.Url.Register, data, (data) => {
			if (success) success(data);
		},
			(xhr) => {
				var err = Ajax.GetError(xhr);
				if (error)
					error(err);
			}
		);
	}
	static getUser(success) {
		Ajax.get(Constants.Url.GetUser, '', (data) => {
			if (success) success(data);
		});

	}

	static updateUser(customer, success, onValidationError) {

		if (customer.deliveryContact && !customer.deliveryContact.email) {
			customer.deliveryContact.email = customer.invoiceContact.email;
        }
		Ajax.post(Constants.Url.UpdateUser, customer, (data) => {
			if (success) success(data);
		},
			(err) => {
				onValidationError(err);
			});
	}

	static mailkitSignUp(email, onSuccess, onError) {
		Ajax.post(Constants.Url.MailkitSignUp, { email: email }, () => {
			if (onSuccess) onSuccess();
		},
			(err) => {
				if (onError) onError(err);
			});
	}

	static leafletsignup(email, onSuccess, onError) {
		Ajax.post(Constants.Url.LeafletSignUp, { email: email }, () => {
			if (onSuccess) onSuccess();
		},
			(err) => {
				if (onError) onError(err);
			});
	}

	static getOrders(success) {
		Ajax.get(Constants.Url.OrderList, 'pageNumber=1&pageSize=100', (data) => {
			if (success) success(data);
		});

	}

	static getOrder(id, success) {
		Ajax.get(Constants.Url.GetOrder, 'id=' + id, (data) => {
			if (success) success(data);
		});
	}

	static getOrderByInvoiceCode(invc, time, success) {
		Ajax.get(Constants.Url.GetOrderByInvoiceCode, 'invc=' + invc + '&time=' + time, success);
	}

	static cancelOrder(invc, time) {
		return Ajax.getPlain(Constants.Url.CancelOrder, 'invc=' + invc + '&time=' + time);
	}

	static sendResetPassword(userName, success) {
		Ajax.get(Constants.Url.SendResetPassword, 'username=' + userName, (data) => {
			if (success) success(data);
		});

	}

	static resetPassword(input, success, error) {
		Ajax.post(Constants.Url.ResetPassword, input, (data) => {
			if (success) success(data);
		},
			(xhr) => {
				if (error)
					error(Ajax.GetError(xhr));
			});
	}
	static changePassword(input, success, onError) {
		Ajax.post(Constants.Url.Manage, input, (data) => {
			if (success) success(data);
		},
			(xhr, status, error) => {
				if (onError)	onError(Ajax.GetError(xhr));
			}

		);
	}

	static signIn(data, success, onError) {
		Ajax.post(Constants.Url.SignIn, data, (jsData) => {

			Storage.instance().token = jsData.access_token;
			Storage.instance().userName = jsData.userName;
			Storage.instance().cachedCart = null;
			Config.isSigned = true;
			AppStore.emit('User.ChangeLogin', Storage.instance().userName);
			UserProvider.loadCartAfterLogin();
            UserProvider.loadUserAfterLogin();
			if (success) success(data);
		},
			(xhr, status, error) => {
				onError(Ajax.GetError(xhr));
			}
		);
	}

	static signOut() {
		Ajax.post(Constants.Url.SignOut, null, () => {

			Storage.instance().clearToken();
			Storage.instance().clearUserName();
			Storage.instance().clearUser();
			CartProvider.clear();
			Storage.instance().customer = new Customer();
			AppStore.emit('User.ChangeLogin', null);
		}
		);
	}

	static loadCartAfterLogin() {
		var cart = Storage.instance().cart;
		if (cart.cartedProducts.length == 0) {
			CartProvider.loadCartFromServer();
		} else {
			CartProvider.calculateCart();
		}
	}


	static loadUserAfterLogin() {
		Ajax.get(Constants.Url.GetUserWithStats, '', (data) => {
			Storage.instance().user = data;
		});
	}
}